import React, { useEffect, useState } from 'react';
import { Button, Header, Input, Message } from 'react-frontier';
import { Modal } from 'semantic-ui-react';
import { bindClick } from '@tempu/components/Util'
import { PostingItem } from '../components';
import { ListPosting } from '../Classes';
import API from '../API';

import '../style/posting_list.scss';

var PostingList = ()=>{
	var [zipcodeModal, setZipcodeModal] = useState<boolean>(false);
	var [postings, setPostings] = useState<ListPosting[]>(null);
	var [zipcode, setZipcode] = useState<number>(JSON.parse(localStorage.getItem("user-data"))?.user.zipcode || null);
	var [loadError, setLoadError] = useState<string>(null);
	var [loading, setLoading] = useState<boolean>(false);

	useEffect(() => {
		// setTitle('OFERTAS DE EMPLEO')
		if(!postings) get()
	}, []);

	var get = async()=>{
		setLoading(true);
		API.getPostingList(zipcode, !!zipcode ? false : true).then(res=>{
			if(res.error) return setLoadError(res.message);
			setPostings(res.data);
			setZipcodeModal(false);
		}).catch(err=>{
			setLoadError('Hubo un error al buscar las ofertas. (LCL-1)');
		}).finally(()=>{
			setLoading(false);
		});
	};

	if(loadError){
		return <Header text='Error' subtext={loadError} />
	}
	
	return <div className="tp posting-list-screen">
		<div className="location">
			<div className="left">Oportunidades</div>
			<div className="zipcode" onClick={bindClick(setZipcodeModal, true)}>
				<i className="map marker alternate icon"></i>
				<div className="text">{zipcode || 'Codigo postal'}</div>
			</div>
		</div>
		<div className="postings">
			{!postings || loading ? (
				new Array(5).fill('TEMPU').map((a,i)=>(
					<PostingItem placeholder key={`PLHPST-${i}`} />
				))
			) : postings.length==0 ? (
				<Header text='No hay oportunidades activas' subtext='Regresa después para ver las oportunidades cercanas a ti' iconName='sad-tear' style={{ marginTop: 50 }} />
			) : postings.map(a=>(
				<PostingItem posting={a} to={`/posting/${a.posting_id}`} key={`PSTNG-${a.posting_id}`} />
			))}
		</div>
		<Modal open={zipcodeModal} onClose={bindClick(setZipcodeModal)} size='mini'>
			<Modal.Header style={{ textAlign: 'center' }}>Código postal</Modal.Header>
			<Modal.Content>
				<Message type='info' centered style={{ marginBottom: 15 }}>
					Ingresa tu código postal para mostrate oportunidades cerca de ti
				</Message>
				<Input label='Código postal' inputStyle={{ textAlign: 'center', fontSize: 20, padding: 10, fontWeight: 'bold' }} labelStyle={{ textAlign: 'center' }} value={zipcode} onChange={setZipcode}/>
			</Modal.Content>
			<Modal.Actions>
				<Button text='Cerrar' basic onClick={bindClick(setZipcodeModal, false)}/>
				<Button text='Guardar' color='black' onClick={get}/>
			</Modal.Actions>
		</Modal>
	</div>
}

export default PostingList;